var map = {
	"./aave.jpg": 4046,
	"./aktionariat.png": 5849,
	"./atomic.jpeg": 8501,
	"./atwallet.png": 8097,
	"./authereum.png": 1365,
	"./binance.png": 8963,
	"./bitkeep.png": 7206,
	"./bitpay.jpeg": 9660,
	"./bnb.png": 3681,
	"./coin98.jpeg": 8590,
	"./coinb.png": 491,
	"./defiat.jpg": 8290,
	"./digitex.png": 2851,
	"./enjin.jpg": 1529,
	"./ethereum-classic.png": 8162,
	"./exodus.jpg": 8380,
	"./flare.jpg": 1052,
	"./icon.png": 5050,
	"./iotex.png": 8343,
	"./kin.png": 7291,
	"./ledger.png": 5506,
	"./loggoo.png": 7707,
	"./math-wallet.png": 2399,
	"./meta.jpeg": 6819,
	"./mew.png": 5522,
	"./nano.png": 9226,
	"./oxen.png": 9162,
	"./portis.png": 6059,
	"./safepall.png": 9036,
	"./scatter.jpg": 4025,
	"./skale.png": 9534,
	"./squarelink.png": 6567,
	"./terra.png": 8041,
	"./theta.png": 8930,
	"./tomo.png": 262,
	"./trezor.png": 937,
	"./tron.png": 985,
	"./trust.jpeg": 8509,
	"./vechain.jpg": 8300,
	"./wanchain.png": 5316,
	"./xrp.png": 3538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4646;